import React, {useState} from "react";
import "./sideBar.modules.css";
import {
    FaAngleDoubleRight,
    FaAngleDoubleLeft,
    FaDatabase,
    FaTable,
    FaUsers,
    FaFileInvoiceDollar,
    FaUserLock,
    FaList,
    FaChartLine,
    FaHandshake,
} from "react-icons/fa";
import {GoHomeFill} from "react-icons/go";
import {useDispatch, useSelector} from "react-redux";
import {setShowSidebar} from "../../../app/globalSlice/globalSlice";
import NavItem from "./NavItem";
import {hasPermission} from "../../../helpers/utils/AccessControlUtils";
import {FaUserGear} from "react-icons/fa6";

function SideBar() {
    const [openDropdown, setOpenDropdown] = useState<string | null>(null);

    const isCollapsed = useSelector((state: any) => state.global.isCollapsed);
    const dispatch = useDispatch();

    const toggleDropdown = (dropdown: string) => {
        setOpenDropdown(openDropdown === dropdown ? null : dropdown);
    };

    return (
        <aside
            id="default-sidebar"
            className={` pt-[50px] left-0 sm:translate-x-0 ${!isCollapsed && "w-52"
            } text-text-0 top-0 transition-transform z-40 bg-highlight-0 fixed h-screen `}
            aria-label="Sidebar"
        >
            <div className={`${!isCollapsed && "overflow-auto h-full"
            } sm:mt-5 md:mt-0 lg:mt-0 `}>
                <ul className="font-medium">

                    <NavItem
                        route="/home"
                        icon={<GoHomeFill className="text-2xl"/>}
                        label="Home"

                    />
                    {hasPermission(["ORDR-V"]) && <NavItem
                        route="/orders"
                        icon={<FaTable className="text-xl"/>}
                        label="Orders"
                    />}

                    {hasPermission(["USR-V", "ROL-V", "TEAM-V"]) && <NavItem
                        route=""
                        icon={<FaUsers className="text-2xl"/>}
                        label="User"
                        dropdownOptions={{
                            childDropdownItems:
                                [
                                    {
                                        label: "Users",
                                        route: "/users",
                                        hasPermission: hasPermission(["USR-V"])
                                    },
                                    {
                                        label: "Roles",
                                        route: "/roles",
                                        hasPermission: hasPermission(["ROL-V"])
                                    },
                                    {
                                        label: "Teams",
                                        route: "/teams",
                                        hasPermission: hasPermission(["TEAM-V"])
                                    },
                                ],
                            isDropdownOpen: openDropdown === "User",
                            onDropdownToggle: () => toggleDropdown("User")
                        }}
                    />}
                    {hasPermission(["CUST-V"]) && <NavItem
                        route="/customers"
                        icon={<FaList className="text-xl"/>}
                        label="Customers"
                    />}

                    {hasPermission(["TRNREPO-V","REVREPO-V", "CTYREPO-V", "AGGUSRREPO-V", "DETUSRREPO-V", "AUTMUNREPO-V", "ACCRECREPO-V", "DLYCUNTREPO-V","ORDREVNT-V","REPOHIS-V"]) && <NavItem
                        route="/data"
                        icon={<FaChartLine className="text-xl"/>}
                        label="Reports"
                        dropdownOptions={{
                            childDropdownItems: [
                                {
                                    label: "Reports",
                                    route: "/turn-around-report",
                                    hasPermission: hasPermission(["TRNREPO-V","REVREPO-V", "CTYREPO-V", "AGGUSRREPO-V", "DETUSRREPO-V", "AUTMUNREPO-V", "ACCRECREPO-V", "DLYCUNTREPO-V"])
                                },
                                {
                                    label: "History",
                                    route: "/report-history",
                                    hasPermission: hasPermission(["REPOHIS-V"])
                                },
                                {
                                    label: "Order Events",
                                    route: "/order-events",
                                    hasPermission: hasPermission(["ORDREVNT-V"])
                                }


                            ],
                            isDropdownOpen: openDropdown === "Reports",
                            onDropdownToggle: () => toggleDropdown("Reports"),
                        }}
                    />}
                    {hasPermission(["VPRC-V", "PTPRC-V", "PRIC-V", "FFPRC-V", "PAYMT-V", "FNFTRANS-V", "REVEVT-V"]) &&
                        <NavItem
                            route="/accounting"
                            icon={<FaFileInvoiceDollar className="text-xl"/>}
                            label="Accounting"
                            dropdownOptions={{
                                childDropdownItems:
                                    [
                                        {
                                            label: "Product Pricing",
                                            route: "/accounting",
                                            hasPermission: hasPermission(["VPRC-V", "PTPRC-V", "PRIC-V", "FFPRC-V"])
                                        },
                                        {
                                            label: "Payments",
                                            route: "/payments",
                                            hasPermission: hasPermission(["PAYMT-V"])
                                        },
                                        {
                                            label: "CRRAR Transactions",
                                            route: "/fnf-transactions",
                                            hasPermission: hasPermission(["FNFTRANS-V"])
                                        },
                                        {
                                            label: "Revenue Events",
                                            route: "/revenue-events",
                                            hasPermission: hasPermission(["REVEVT-V"])
                                        }

                                    ],
                                isDropdownOpen: openDropdown === "Accounting",
                                onDropdownToggle: () => toggleDropdown("Accounting")
                            }}
                        />}
                    {hasPermission(["MGTCOM-V", "ASSOC-V", "AUTOHOA-V", "FEESORT-V", "HOATPP-V"]) && <NavItem
                        route="/data"
                        icon={<FaHandshake className="text-xl"/>}
                        label="HOA"
                        dropdownOptions={{
                            childDropdownItems: [
                                {
                                    label: "Mgmt Companies",
                                    route: "/management-companies",
                                    hasPermission: hasPermission(["MGTCOM-V"])
                                },
                                {
                                    label: "Associations",
                                    route: "/associations",
                                    hasPermission: hasPermission(["ASSOC-V"])
                                },
                                {
                                    label: "Auto HOA",
                                    route: "/auto-hoa",
                                    hasPermission: hasPermission(["AUTOHOA-V"])
                                },
                                {
                                    label: "Fee Sorting",
                                    route: "/hoa-fee-types",
                                    hasPermission: hasPermission(["FEESORT-V"])
                                },
                                {
                                    label: "Third Party Provider",
                                    route: "/third-party-providers",
                                    hasPermission: hasPermission(["HOATPP-V"])
                                }


                            ],
                            isDropdownOpen: openDropdown === "HOA",
                            onDropdownToggle: () => toggleDropdown("HOA"),
                        }}
                    />}
                    {hasPermission(["STAT-V", "COUN-V", "CANFN-V", "COLL-V", "CANNOTE-V", "COLLINK-V", "CANIL-V", "BILLREL-V", "JURI-V", "STATCODE-V", "TAXR-V", "APRROL-V", "SUBD-V", "METR-V", "LINKACC-V", "HRAV-V", "HRA-V", "TAXRCONF-V"]) &&
                        <NavItem
                            route="/data"
                            icon={<FaDatabase className="text-xl"/>}
                            label="Data"
                            dropdownOptions={{
                                childDropdownItems: [
                                    {
                                        label: "Canned Notes",
                                        route: "/canned-notes",
                                        hasPermission: hasPermission(["CANNOTE-V"])
                                    },
                                    {
                                        label: "Collectors",
                                        route: "/collectors",
                                        hasPermission: hasPermission(["COLL-V"])
                                    },
                                    {
                                        label: "Collector Links",
                                        route: "/collector-links",
                                        hasPermission: hasPermission(["COLLINK-V"])
                                    },
                                    {
                                        label: "Counties",
                                        route: "/counties",
                                        hasPermission: hasPermission(["COUN-V"])
                                    },
                                    {
                                        label: "Bill Release",
                                        route: "/bill-release",
                                        hasPermission: hasPermission(["BILLREL-V"])
                                    },
                                    {
                                        label: "Jurisdictions",
                                        route: "/jurisdictions",
                                        hasPermission: hasPermission(["JURI-V"])
                                    },
                                    {
                                        label: "States",
                                        route: "/states",
                                        hasPermission: hasPermission(["STAT-V"])
                                    },
                                    {
                                        label: "State Codes",
                                        route: "/state-codes",
                                        hasPermission: hasPermission(["STATCODE-V"])
                                    },

                                    {
                                        label: "Tax Rolls",
                                        route: "/tax-rolls",
                                        hasPermission: hasPermission(["TAXR-V"])
                                    },

                                    {
                                        label: "Appraisal Rolls",
                                        route: "/appraisal-rolls",
                                        hasPermission: hasPermission(["APRROL-V"])
                                    },
                                    {
                                        label: "Subdivisions",
                                        route: "/subdivisions",
                                        hasPermission: hasPermission(["SUBD-V"])
                                    },

                                    {
                                        label: "Metro Areas",
                                        route: "/metro-areas",
                                        hasPermission: hasPermission(["METR-V"])
                                    },

                                    {
                                        label: "Canned File Names",
                                        route: "/canned-file-names",
                                        hasPermission: hasPermission(["CANFN-V"])
                                    },


                                    {
                                        label: "Canned Invoice Lines",
                                        route: "/canned-invoice-lines",
                                        hasPermission: hasPermission(["CANIL-V"])
                                    },
                                    {
                                        label: "Linked Accounts",
                                        route: "/linked-accounts",
                                        hasPermission: hasPermission(["LINKACC-V"])
                                    },

                                    {
                                        label: "Verified HRA",
                                        route: "/verified-high-risk-accounts",
                                        hasPermission: hasPermission(["HRAV-V"])
                                    },
                                    {
                                        label: "High Risk Acc",
                                        route: "/high-risk-accounts",
                                        hasPermission: hasPermission(["HRA-V"])
                                    },

                                    {
                                        label: "Tax Rounding Config",
                                        route: "/tax-rounding-config",
                                        hasPermission: hasPermission(["TAXRCONF-V"])
                                    },
                                ],
                                isDropdownOpen: openDropdown === "Data",
                                onDropdownToggle: () => toggleDropdown("Data"),
                            }}
                        />}
                    {hasPermission(["DATARETVAL-V", "LOGIC-V", "SCRMOD-V", "FOLLUP-V", "AUDIT-V"]) && <NavItem
                        route="/tenat-admin"
                        icon={<FaUserGear className="text-2xl"/>}
                        label="Tenant Admin"
                        dropdownOptions={{
                            childDropdownItems: [
                                {
                                    label: "Import Versions",
                                    route: "/import-versions",
                                    hasPermission: hasPermission(["DATARETVAL-V"])
                                },
                                {
                                    label: "QC Logics",
                                    route: "/qc-logics",
                                    hasPermission: hasPermission(["LOGIC-V"])
                                },
                                {
                                    label: "Note Logics",
                                    route: "/note-logics",
                                    hasPermission: hasPermission(["LOGIC-V"])
                                },
                                {
                                    label: "Scraper Modules",
                                    route: "/scrapers-modules",
                                    hasPermission: hasPermission(["SCRMOD-V"])
                                },
                                {
                                    label: "Follow Up Types",
                                    route: "/follow-up-types",
                                    hasPermission: hasPermission(["FOLLUP-V"])
                                },
                                {
                                    label: "Record Audit",
                                    route: "/record-audit",
                                    hasPermission: hasPermission(["AUDIT-V"])
                                },
                            ],
                            isDropdownOpen: openDropdown === "Tenant Admin",
                            onDropdownToggle: () => toggleDropdown("Tenant Admin"),
                        }}
                    />}

                    {hasPermission(["SPRO-V", "ERRLOG-V", "SCRMOD-V", "CODES-V", "ACCTRA-V", "TEN-V"]) && <NavItem
                        route="/system-admin"
                        icon={<FaUserLock className="text-2xl"/>}
                        label="System Admin"
                        dropdownOptions={{
                            childDropdownItems: [
                                {
                                    label: "System Properties",
                                    route: "/system-properties",
                                    hasPermission: hasPermission(["SPRO-V"])
                                },
                                {
                                    label: "Error Logs",
                                    route: "/error-logs",
                                    hasPermission: hasPermission(["ERRLOG-V"])
                                },
                                {
                                    label: "Registered Scrapers",
                                    route: "/registered-scrapers",
                                    hasPermission: hasPermission(["SCRMOD-V"])
                                },
                                {
                                    label: "Codes",
                                    route: "/codes",
                                    hasPermission: hasPermission(["CODES-V"])
                                },
                                {
                                    label: "Account Translations",
                                    route: "/account-translations",
                                    hasPermission: hasPermission(["ACCTRA-V"])
                                },
                                {
                                    label: "Tenants",
                                    route: "/tenants",
                                    hasPermission: hasPermission(["TEN-V"])
                                },
                            ],
                            isDropdownOpen: openDropdown === "System Properties",
                            onDropdownToggle: () => toggleDropdown("System Properties"),
                        }}
                    />}


                    <li className={`toggle_btn fixed bottom-3 ${isCollapsed === true ? "left-5" : "left-40 "} `}>
                        <button
                            type="button"
                            onClick={() => dispatch(setShowSidebar(!isCollapsed))}
                            className="navbar-brand navbar_toggle_btn"
                            id="sidebar-toggle"
                        >
                            {isCollapsed === true ? <FaAngleDoubleRight/> : <FaAngleDoubleLeft/>}
                        </button>

                    </li>
                </ul>
            </div>
        </aside>
    );
}

export default SideBar;
